/*
 * Created Date: 16-01-2024, 10:20:57 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Tue Mar 12 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React from 'react'
import { ROUTER_WORKSPACE_CATEGORIES } from './const'
import { userRole } from '@App/Studio/app-config/const'
const CategoriesLazy = React.lazy(() => import('../index'))

export const workspaceCategoriesRouterConfig = {
	auth: [userRole.admin],
	settings: {
		layout: {
			config: {
				sidebar: {
					display: true
					// collapsed: true
				},
				header: {
					display: true
				}
			}
		}
	},
	routes: [
		{
			path: ROUTER_WORKSPACE_CATEGORIES.list,
			element: <CategoriesLazy />
		}
	]
}
